import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Card from '@material-ui/core/Card';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { isFeatureDisabled } from '../../helpers/outageHelpers';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

import ProfileLayout from './ProfileLayout';
import TenancyInformationLandingCard from './landings/TenancyInformationLandingCard/TenancyInformationLandingCard';
import AccountDetailsLandingCard from './landings/AccountDetailsLandingCard/AccountDetailsLandingCard';
import ContactDetailsLandingCard from './landings/ContactDetailsLandingCard/ContactDetailsLandingCard';
import EmergencyContactsLandingCard from './landings/EmergencyContactsLandingCard/EmergencyContactsLandingCard';
import ConsentedPersonsLandingCard from './landings/ConsentedPersonsLandingCard/ConsentedPersonsLandingCard';
import NotificationsLandingCard from './landings/NotificationsLandingCard/NotificationsLandingCard.js';

class Profile extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { onLoadComplete } = this.props;

    onLoadComplete();
  }

  render() {
    const { goProfileChild, goDash, tenancy } = this.props;

    const tenancyData = tenancy.data;

    const tenancyInformationLanding = (
      <TenancyInformationLandingCard
        action={() => goProfileChild('Tenancy-Information')}
      />
    );
    const accountDetailsLanding = (
      <AccountDetailsLandingCard
        action={() => goProfileChild('Account-Details')}
      />
    );
    const contactDetailsLanding = (
      <ContactDetailsLandingCard
        action={() => goProfileChild('Contact-Details')}
      />
    );
    const emergencyContactsLanding = (
      <EmergencyContactsLandingCard
        action={() => goProfileChild('Emergency-Contacts')}
      />
    );
    const consentedPersonsLanding = (
      <ConsentedPersonsLandingCard
        action={() => goProfileChild('Consented-Persons')}
      />
    );
    const notificationsLanding = !isFeatureDisabled(
      'NOTIFICATIONS',
      tenancyData.area
    ) ? (
      <NotificationsLandingCard
        action={() => goProfileChild('Notifications')}
      />
    ) : null;

    return (
      <ProfileLayout
        tenancyInformationLanding={tenancyInformationLanding}
        accountDetailsLanding={accountDetailsLanding}
        contactDetailsLanding={contactDetailsLanding}
        emergencyContactsLanding={emergencyContactsLanding}
        consentedPersonsLanding={consentedPersonsLanding}
        notificationsLanding={notificationsLanding}
        backAction={goDash}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  tenancy: state.customer.tenancy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
